export default __webpack_public_path__ + "static/media/documentation.5d7681bc.svg";